// extracted by mini-css-extract-plugin
export default {"container":"PopUpComponent_container__yhT32"};